import { Chip } from "@material-ui/core";
import { memo } from "react";
import { useContasPagarService } from "../context/ContasPagarContext";

const SituationChip = ({ situation }) => {
  const { handleRemoveChip } = useContasPagarService();

  return (
    <>
      <Chip
        key={situation.id}
        label={situation.desc}
        onDelete={() => {
          handleRemoveChip(situation);
        }}
        color={"primary"}
      />
    </>
  );
};

export default memo(SituationChip);
